import { captureCurrentUndoable } from "@/components/pitchCorrection/undo/captureCurrentUndoable";
import {
  UndoTransition,
  UndoTransitionInputs,
} from "@/types/defs/pitchCorrection/undo";

// Re-applies exactly one entry off the redo stack — redo never gesture-batches, so each redo press replays one undo press. The displaced current state is captured onto the undo stack. Returns null when there is nothing to redo.
export const computeRedoTransition = ({
  undoStack,
  redoStack,
  currentPitchState,
  currentCircles,
  now,
}: UndoTransitionInputs): UndoTransition | null => {
  const restored = redoStack[redoStack.length - 1];
  if (restored === undefined) {
    return null;
  }
  return {
    undoStack: [
      ...undoStack,
      captureCurrentUndoable({
        restored,
        currentPitchState,
        currentCircles,
        now,
      }),
    ],
    redoStack: redoStack.slice(0, redoStack.length - 1),
    restored,
  };
};
